// services/api.ts
let tokenProvider: () => Promise<string> = async () => "";

/**
 * Configura a função que vai fornecer o token.
 * Ex.: setTokenProvider(() => msalInstance.acquireTokenSilent(...))
 */
export function setTokenProvider(fn: () => Promise<string>) {
  tokenProvider = fn;
}

const BASE = "/api";

/**
 * PUT genérico em JSON, já incluindo Bearer token no header.
 */
export async function putJSON<T = any>(path: string, body: any): Promise<T | null> {
  const url = `${BASE}${path}`;
  const token = (await tokenProvider()) || "";

  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      console.warn("PUT fail", res.status, res.statusText);
      return null;
    }

    return res.json();
  } catch (err) {
    console.error("PUT error", err);
    return null;
  }
}

/**
 * POST genérico em JSON, já incluindo Bearer token no header.
 */
export async function postJSON<T = any>(path: string, body: any): Promise<T | null> {
  const url = `${BASE}${path}`;
  const token = (await tokenProvider()) || "";

  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: "include",
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      console.warn("POST fail", res.status, res.statusText);
      return null;
    }

    return res.json();
  } catch (err) {
    console.error("POST error", err);
    return null;
  }
}

/**
 * GET genérico em JSON, já incluindo Bearer token no header.
 */
export async function getJSON<T = any>(path: string): Promise<T | null> {
  const url = `${BASE}${path}`;
  const token = (await tokenProvider()) || "";

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      credentials: "include",
    });

    if (!res.ok) {
      console.warn("GET fail", res.status, res.statusText);
      return null;
    }

    const ct = res.headers.get("content-type") || "";
    return ct.includes("application/json") ? res.json() : null;
  } catch (err) {
    console.error("GET error", err);
    return null;
  }
}